import React from 'react'
import { useFormContext, useFormState, useWatch } from 'react-hook-form'

const ActiveTextAreaField = ({ field }) => {
  const formContext = useFormContext()
  const { errors, isSubmitted } = useFormState({ control: formContext.control })

  const error = errors[field.idFieldCanvas]
  let textAreaClass = ''

  if (isSubmitted) {
    textAreaClass = error ? 'input-error' : 'input-success'
  }

  const input_style = field.input_design ? { ...field.input_design } : {}

  const register = formContext.register

  const inputProps = register(field.idFieldCanvas.toString(), {
    required: field.required,
    maxLength: field.has_max_length ? field.max_length : undefined,
  })

  const currentValue = useWatch({
    control: formContext.control,
    name: field.idFieldCanvas.toString(),
  })

  return (
    <>
      <textarea
        {...inputProps}
        defaultValue={field.VALUE__reponse ? field.VALUE__reponse : ''}
        className={textAreaClass}
        style={input_style}
        placeholder={field.placeholder}
        rows="5"
        maxLength={field.has_max_length ? field.max_length : undefined}
      />
      {field.has_max_length && (
        <div
          style={{
            fontSize: '11px',
            color: input_style.color,
            marginTop: '10px',
            marginLeft: '5px',
          }}
        >
          {currentValue?.length || 0}/{field.max_length} caractères
        </div>
      )}
    </>
  )
}

const InactiveTextAreaField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}
  const [value, setValue] = React.useState(field.VALUE__reponse || '')

  return (
    <>
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        style={input_style}
        placeholder={field.placeholder}
        rows="5"
        maxLength={field.has_max_length ? field.max_length : undefined}
      />
      {field.has_max_length && (
        <div
          style={{
            fontSize: '11px',
            color: input_style.color,
            marginTop: '10px',
            marginLeft: '5px',
          }}
        >
          {value.length}/{field.max_length} caractères
        </div>
      )}
    </>
  )
}

const TextAreaField = ({ field, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveTextAreaField field={field} />
  ) : (
    <InactiveTextAreaField field={field} />
  )
}

export default TextAreaField
